import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconApple",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function p(e, t, r, _, u, a) {
  return d(), l("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--apple"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Apple",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      d: "M20.425 7.5c-.128.1-2.392 1.37-2.392 4.192 0 3.265 2.88 4.42 2.967 4.449-.013.07-.458 1.582-1.519 3.122-.946 1.355-1.935 2.708-3.438 2.708-1.504 0-1.89-.869-3.626-.869-1.692 0-2.293.898-3.668.898-1.376 0-2.335-1.254-3.438-2.794C4.033 17.397 3 14.588 3 11.92c0-4.277 2.795-6.546 5.545-6.546 1.462 0 2.68.955 3.598.955.873 0 2.235-1.012 3.898-1.012.63 0 2.894.057 4.384 2.183Zm-5.174-3.993c.688-.812 1.174-1.938 1.174-3.065 0-.156-.013-.314-.042-.442-1.118.042-2.45.741-3.252 1.668-.63.713-1.218 1.84-1.218 2.981 0 .172.028.343.042.398.07.014.185.029.3.029 1.004 0 2.267-.669 2.996-1.569Z",
      fill: "#888"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ o(c, [["render", p]]);
export {
  g as default
};
//# sourceMappingURL=apple.js.map
